import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {StompHeaders} from '@stomp/stompjs';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  sensorDataChangeEmitter: EventEmitter<any> = new EventEmitter();
  sock_connected: EventEmitter<any> = new EventEmitter();
  greetings: string[] = [];
  disabled: boolean;
  name: string;
  private stompClient = null;
  subscriptions = {};
  connected = false;

  socketBaseUrl = DDP_ENV.socketBaseUrl;
  constructor(private cookieService: CookieService) {}
  setConnected(connected: boolean) {
    this.disabled = !connected;
    if (connected) {
      this.greetings = [];
    }
  }

    connect() {
        const protocols = ['websocket', 'xhr-polling'];
        const headers = {
            'Authorization': 'bearer ' + this.cookieService.get('ecare_access_token'),
        }
        const socket = new SockJS(this.socketBaseUrl, null, {
            transports: protocols, headers
        });
        this.stompClient = Stomp.over(socket);
        return this.stompClient;
    }

/*  connect(topic: string) {
    const socket = new SockJS(this.socketBaseUrl/!* + '/?access_token=' + this.cookieService.get('ecare_access_token')*!/);
    //const socket = new SockJS(this.socketBaseUrl);
      let headers = {};
      headers['Authorization'] = 'bearer ' + this.cookieService.get('ecare_access_token');
      this.stompClient = Stomp.over(socket, headers);
      this.connected = true;
    this.sock_connected.emit(this.connected);
    return this.stompClient;
  }*/

  onmessage = function(sensorData) {
    this.sensorDataChangeEmitter.emit(JSON.parse(sensorData.body));
    return sensorData;
  };

  disconnect() {
    if (this.stompClient != null) {
      this.stompClient.disconnect();
    }
    this.setConnected(false);
    console.log('Disconnected!');
  }

  unsubscribe(subscriptions: any, id: string) {
    const subscription = subscriptions[id];
    if (!subscription) {
      console.warn('Couldn\'t unsubscribe: id=' + id);
      return false;
    }
    subscription.unsubscribe();
    delete(subscriptions[id]);
    console.log('Unsubscribed from topic=' + subscription.topic + ' id=' + id);
    if (subscriptions === {}) {
      this.disconnect();
    }
    return true;
  }
}
